export const ServiceCollectionBackgroundSvg = () => (
    <svg
        width={484}
        height={568}
        viewBox="0 0 484 568"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <mask
            id="mask0_14_2203"
            style={{
                maskType: "alpha"
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={484}
            height={568}
        >
            <path d="M46.1455 0H484V568H0L46.1455 0Z" fill="#F83030" />
        </mask>
        <g mask="url(#mask0_14_2203)">
            <rect width={484} height={568} fill="#FEF7C8" />
        </g>
        <mask
            id="mask1_14_2203"
            style={{
                maskType: "alpha"
            }}
            maskUnits="userSpaceOnUse"
            x={52}
            y={54}
            width={388}
            height={448}
        >
            <path
                opacity={0.5}
                d="M340.137 54.1895L439.27 424.161L151.719 501.21L52.5855 131.239L340.137 54.1895Z"
                fill="#CFE1FD"
            />
        </mask>
        <g mask="url(#mask1_14_2203)">
            <line
                x1={422.181}
                y1={60.3694}
                x2={-37.754}
                y2={60.3694}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={422.181}
                y1={95.7278}
                x2={-37.754}
                y2={95.7278}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={422.181}
                y1={131.086}
                x2={-37.754}
                y2={131.086}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={422.181}
                y1={166.445}
                x2={-37.754}
                y2={166.445}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={422.181}
                y1={201.803}
                x2={-37.754}
                y2={201.803}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={422.181}
                y1={237.161}
                x2={-37.754}
                y2={237.161}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={422.181}
                y1={272.52}
                x2={-37.754}
                y2={272.52}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={422.181}
                y1={307.878}
                x2={-37.754}
                y2={307.878}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={422.181}
                y1={343.236}
                x2={-37.754}
                y2={343.236}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={422.181}
                y1={378.595}
                x2={-37.754}
                y2={378.595}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={422.181}
                y1={413.953}
                x2={-37.7541}
                y2={413.953}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={422.181}
                y1={449.312}
                x2={-37.7541}
                y2={449.311}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={420.285}
                y1={484.67}
                x2={-35.8574}
                y2={484.67}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={402.568}
                y1={-275.006}
                x2={402.568}
                y2={825.994}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={367.209}
                y1={-275.006}
                x2={367.209}
                y2={825.994}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={331.851}
                y1={-275.006}
                x2={331.851}
                y2={825.994}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={296.492}
                y1={-275.006}
                x2={296.492}
                y2={825.994}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={261.134}
                y1={-275.006}
                x2={261.134}
                y2={735.994}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={225.776}
                y1={-275.006}
                x2={225.776}
                y2={735.994}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={190.417}
                y1={-275.006}
                x2={190.417}
                y2={735.994}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={155.059}
                y1={-275.006}
                x2={155.059}
                y2={735.994}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={119.701}
                y1={-275.006}
                x2={119.701}
                y2={735.994}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
            <line
                x1={84.3423}
                y1={-275.006}
                x2={84.3422}
                y2={735.994}
                stroke="#F2AC00"
                strokeWidth={0.94832}
            />
        </g>
    </svg>
);
